export function IntegrationsFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/integrations-filled.svg'"></ng-include>`
    }
}